import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import de from "shared/common/translations/de.json";
import en from "shared/common/translations/en.json";
import fr from "shared/common/translations/fr.json";

const resources = {
  en,
  de,
  fr,
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug: false,
    supportedLngs: ["de", "en", "fr"],
    nonExplicitSupportedLngs: true,
    fallbackLng: "en",
    resources,
  });

export default i18n;
